import { mapState } from 'vuex';

export default {
  name: 'match-search-mixin',

  data() {
    return {
      searchLeague: [],
    };
  },

  computed: {
    ...mapState(['user_data']),
  },

  watch: {
    searchLeague(newValue) {
      if (newValue.length > 3) {
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Max. 3 Auswahlmöglichkeiten',
        });
        setTimeout(() => {
          newValue.pop();
        }, 10);
      }
    },

    'user_data.search_verband': function (value) {
      this.searchLeague = [];
    },
  },

  methods: {
    saveAndClose() {
      this.$store.state.user_data.search_league = this.searchLeague;
      this.$emit('save-and-close');
    },
  },

  created() {
    if (Array.isArray(this.user_data.search_league)) {
      this.searchLeague = this.user_data.search_league;
    } else if (this.user_data.search_league) {
      this.searchLeague.push(this.user_data.search_league);
    }
  },
};
